// extracted by mini-css-extract-plugin
module.exports = {"section":"conceito_section__2IGIu","preco":"conceito_preco__kT8XO"};